import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  adminConnected,
  adminDisconnected,
  loadLeads,
  sendMessage,
  setActiveLead,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(adminConnected.type, send, socket);
  yield takeEvery(adminDisconnected.type, send, socket);
  yield takeEvery(loadLeads.type, send, socket);
  yield takeEvery(sendMessage.type, send, socket);
  yield takeEvery(setActiveLead.type, send, socket);
}
